export interface Endpoints {
    login: string;
    logout: string;
    postSignup: string;
    refreshToken: string;
    getConsultation: string;
    updateConsultation: string;
    getConsultationsList: string;
    getOpenConsultations: string;
    postPatientConsultation: string;
    cancelPatientConsultation: string,
    getScheduledConsultations: string;
    postDoctorScheduleConsultation: string;
    getDoctorScheduledConsultationsByDate: string;
    updateConsultationReport: string;
    getUploadUrlGenerator: string;
    getDoctorProfessionalDetails: string;
    postDoctorProfessionalDetails: string;
    patchDoctorProfessionalDetails: string;
    getDoctorPracticeDetails: string;
    postDoctorPracticeDetails: string;
    patchDoctorPracticeDetails: string;
    patchUserDetails: string;
    postResetPasswordFindAccount: string;
    postResetPasswordVerifyOTP: string;
    postResetPasswordUpdatePassword: string;
    getTreatmentsList: string;
    getTreatmentCategoriesList: string;
    getSpecializationsList: string;
    getTreatmentDetails: string;
    getSpecializationDetails: string;
    getTreatmentCategoriesDetails: string;
    postUserDocuments: string;
    getUserDocumentsList: string;
    getUserDocument: string;
    deleteUserDocument: string;
    updateUserDocument: string;
    newDocumentUpload: string;
    postCallLog: string;
    postConsultationInvoice: string;
    patchConsultationDoctorCompleted: string;
    getInsurances: string;
    postInsurances: string;
    deleteInsurance: string;
    getMedicalRates: string;
    patchConsMedicalCharge: string;
    patchDoctorBankAccountDetails: string;
    getDoctorBankAccountDetails: string;
    anonymousConsultation: string;
    postDoctorScheduleConsultationTempUser: string;
    anonymousLogin: string;
    verifyemail: string;
    verifyToken:string;
    addPatientDetails:string;
    verifyGrouptoken:string;
    updateGroupSize:string;
    patientWaiting:string
}

export enum EndpointName {
    login = 'login',
    logout = 'logout',
    postSignup = 'postSignup',
    verifyemail = 'verifyemail',
    refreshToken = 'refreshToken',
    getConsultation = 'getConsultation',
    updateConsultation = 'updateConsultation',
    getConsultationsList = 'getConsultationsList',
    getOpenConsultations = 'getOpenConsultations',
    getScheduledConsultations = 'getScheduledConsultations',
    updateConsultationReport = 'updateConsultationReport',
    getUploadUrlGenerator = 'getUploadUrlGenerator',
    getDoctorProfessionalDetails = 'getDoctorProfessionalDetails',
    getDoctorBankAccountDetails = 'getDoctorBankAccountDetails',
    postDoctorProfessionalDetails = 'postDoctorProfessionalDetails',
    patchDoctorProfessionalDetails = 'patchDoctorProfessionalDetails',
    getDoctorPracticeDetails = 'getDoctorPracticeDetails',
    postDoctorPracticeDetails = 'postDoctorPracticeDetails',
    patchDoctorPracticeDetails = 'patchDoctorPracticeDetails',
    getDoctorScheduledConsultationsByDate = 'getDoctorScheduledConsultationsByDate',
    postDoctorScheduleConsultation = 'postDoctorScheduleConsultation',
    patchUserDetails = 'patchUserDetails',
    patchDoctorBankAccountDetails = 'patchDoctorBankAccountDetails',
    postResetPasswordFindAccount = 'postResetPasswordFindAccount',
    postResetPasswordVerifyOTP = 'postResetPasswordVerifyOTP',
    postResetPasswordUpdatePassword = 'postResetPasswordUpdatePassword',
    getTreatmentsList = 'getTreatmentsList',
    getTreatmentCategoriesList = 'getTreatmentCategoriesList',
    getSpecializationsList = 'getSpecializationsList',
    getTreatmentDetails = 'getTreatmentDetails',
    getSpecializationDetails = 'getSpecializationDetails',
    getTreatmentCategoriesDetails = 'getTreatmentCategoriesDetails',
    postPatientConsultation = 'postPatientConsultation',
    cancelPatientConsultation = 'cancelPatientConsultation',
    postUserDocuments = 'postUserDocuments',
    getUserDocumentsList = 'getUserDocumentsList',
    getUserDocument = 'getUserDocument',
    deleteUserDocument = 'deleteUserDocument',
    updateUserDocument = 'updateUserDocument',
    newDocumentUpload = 'newDocumentUpload',
    postCallLog = 'postCallLog',
    postConsultationInvoice = 'postConsultationInvoice',
    patchConsultationDoctorCompleted = 'patchConsultationDoctorCompleted',
    getInsurances = 'getInsurances',
    postInsurances = 'postInsurances',
    deleteInsurance = 'deleteInsurance',
    getMedicalRates = 'getMedicalRates',
    patchConsMedicalCharge = 'patchConsMedicalCharge',
    anonymousConsultation = 'anonymousConsultation',
    postDoctorScheduleConsultationTempUser = 'postDoctorScheduleConsultationTempUser',
    anonymousLogin = `anonymousLogin`,
    verifyToken=`verifyToken`,
    addPatientDetails=`addPatientDetails`,
    verifyGrouptoken=`verifyGrouptoken`,
    updateGroupSize=`updateGroupSize`,
    patientWaiting=`patientWaiting`
}